class ShippingBar extends HTMLElement {
  constructor() {
    super();

    this.threshold = Number(this.dataset.threshold) || 5000;
    this.freeShipSub = this.dataset.freeshipSub === 'true';
  }

  connectedCallback() {
    this.textEl = this.querySelector('.shipping-bar__text');
    this.progressWrapper = this.querySelector('.shipping-bar__progress');
    this.progressEl = this.querySelector('.shipping-bar__progress-inner');

    this.listen();
    this.refresh(); // initial
  }

  listen() {
    document.addEventListener('cart:updated', () => {
      this.refresh();
    });
  }

  async refresh() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      this.updateUI(cart);

    } catch (e) {
      console.error('Shipping bar error:', e);
    }
  }

  updateUI(cart) {
    const total = cart.total_price;

    const hasSubscription = cart.items.some(item => item.selling_plan_allocation);

    const isFreeShippingByPrice = total >= this.threshold;
    const isFreeShippingBySub = this.freeShipSub && hasSubscription;

    const isFreeShipping = isFreeShippingByPrice || isFreeShippingBySub;

    this.breakpointIcon = this.progressWrapper.querySelector(
      `[data-threshold-item='${this.threshold}'] svg circle`
    );

    // TEXT
    if (isFreeShippingBySub) {
      this.textEl.textContent = `You’ve Unlocked Free Shipping With Your Subscription`;
      this.querySelector('.shipping-bar__breakpoint-price').style.display = 'none';
    } else if (isFreeShippingByPrice) {
      this.textEl.textContent = `You’ve Unlocked Free Domestic Shipping`;
      this.querySelector('.shipping-bar__breakpoint-price').style.display = 'block';
    } else {
      this.querySelector('.shipping-bar__breakpoint-price').style.display = 'block';
      const remaining = this.threshold - total;
      const dollars = (remaining / 100).toFixed(2);

      this.textEl.textContent = `You're $${dollars} away from free domestic shipping`;
    }

    // ICON
    if (isFreeShipping) {
      this.breakpointIcon.style.fill = '#485CC7';
      this.breakpointIcon.style.stroke = '#8194F5';
    } else {
      this.breakpointIcon.style.fill = '#FFF9F6';
      this.breakpointIcon.style.stroke = '#C1BEBD';
    }

    // PROGRESS
    const progress = isFreeShipping
      ? 100
      : Math.min((total / this.threshold) * 100, 100);

    this.progressEl.style.width = `${progress}%`;
  }
}

customElements.define('shipping-bar', ShippingBar);
